var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDaiStar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0_20845_570)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.446 3.72l1.79-3.322a.745.745 0 011.317 0l1.789 3.323 3.267 1.82a.77.77 0 010 1.34L32.342 8.7l-1.79 3.322a.745.745 0 01-1.317 0l-1.789-3.322-3.267-1.82a.77.77 0 010-1.34l3.267-1.82zM9.657 14.037l4.72-8.772a1.966 1.966 0 013.48 0l4.72 8.772 8.624 4.801c1.376.764 1.376 2.775 0 3.54l-8.625 4.8-4.72 8.773a1.966 1.966 0 01-3.48 0l-4.72-8.772-8.624-4.802c-1.376-.764-1.376-2.774 0-3.539l8.625-4.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0_20845_570"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v37H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaiStar);
export default __webpack_public_path__ + "static/media/dai-star.05f341f5b2154dc2d4db00dace4061b1.svg";
export { ForwardRef as ReactComponent };